export interface Packaging {
    id: number;
    code: string;
    description: string;
    description_plural: string;
    transport_mode: string;
    load_type: string;
}
